import { AbstractControl, ValidationErrors } from "@angular/forms";
import { ValuationEventsFormComponent } from "./valuation-events-form.component";

/**
 * Pollux form validators
 */
export class ValuationEventsValidators {

  /**
   * Validates the template
   * @returns
   */
  static template() {
    return (form: ValuationEventsFormComponent) => {
      return (control: AbstractControl): ValidationErrors | null => {
        try {
          if (form.formReady && form.formData) {
            const templateId = control.value;
            const languageId = control.parent.controls['LanguageId'].value;
            const templates = form.availableTemplates.filter((tmp) => { return tmp.templateLanguages.indexOf(languageId) >= 0; });
            const templateMatchesLanguage = templates.find((tmp) => { return tmp.Oid === templateId; });
            if (templateMatchesLanguage) {
              return null;
            }
            else {
              return { 'invalidLanguageAndTemplate': true };
            }
          }
        } catch (e) {
          //Not ready - ignore
        }
        return null;
      };
    }
  }
}
